/**
 * Created by Dong on 2017/5/16.
 */
'use strict';
import {serviceRequestActions, dashboardActions} from '../actions'
import {constants as kandyConstants} from 'kandy-redux'
import {isFSA} from 'flux-standard-action'
import * as types  from '../constants/ActionTypes'
import schedule from 'node-schedule'
import _ from 'lodash'

global.timerArr = [];//计时队列
let schedule_id;
let middleware = ({dispatch, getState}) => {
	return next => action => {
		if (isFSA(action)) {
			if (action.type === types.START_SESSION_FINISH) {
				/* 开始会话，把当前会话添加到计时队列
				 如果 计时器为null，则开始 计时器*/

				if(!action.error){
					let customerFullUserId = action.payload.serviceRequest.userId;
					let name = action.payload.serviceRequest.userInfo.name || customerFullUserId;



					if (action.payload.serviceRequest.userId) {
						let newTimer = {
							id: customerFullUserId,
							name: name,
							timer: 0
						};
						global.timerArr = [...timerArr, newTimer]
						if (!schedule_id) {
							startAddTime(dispatch, action.payload.waitTime>0 ? action.payload.waitTime*60 : 300);
						}
					}
				}
			}
			else if (action.type === kandyConstants.MESSAGE_RECEIVED
				|| action.type === kandyConstants.MESSAGE_IMAGE_RECEIVED
				|| action.type === kandyConstants.MESSAGE_AUDIO_RECEIVED
				|| action.type === kandyConstants.MESSAGE_VIDEO_RECEIVED
				|| action.type === kandyConstants.MESSAGE_FILE_RECEIVED) {
				/*   当收到customer消息时，刚重置当前会话时间为0*/
				let customerFullUserId = action.payload.message.sender.full_user_id;
				_.map(timerArr, function (item) {
					if (item.id == customerFullUserId) {
						item.timer = 0;

					}
					return item;

				});

			}
		
			else if (action.type === kandyConstants.CALL_REJECTED) {
				/*当执行拒接操作后，将timer设置为0，重新开始超时操作*/
				let currentCall = getState().app.kandy.calls[0];
				let customerFullUserId = currentCall.calleeFullUserId;
				_.map(timerArr, function (item) {
					if (item.id == customerFullUserId) {
						item.timer = 0;

					}
					return item;
				});
			}
			else if (action.type === types.END_SESSION) {
				//结束会话 将从计时队列中移除当前会话，如果 队列为空，则关闭计时器
				let customerFullUserId = action.payload.userId;
				_.remove(timerArr, function (obj) {
					return obj.id = customerFullUserId
				})
				if (timerArr.length === 0) {
				    if (schedule_id)
					    schedule_id.cancel();
					schedule_id = null;
				}
			}

		}
		return next(action);
		//
	}
};
/*
 * 定时器
 * 定时给每个会话客户计时，当累计时长达到超时标准后，发送提醒消息，再次计时
 * *  *  *  *  *  *通配符表示 :秒、分、时、日、月、周几
 * */
let startAddTime = (dispatch, timeout) => {

	schedule_id = schedule.scheduleJob("*  *  *  *  *  *", function () {
		_.map(timerArr, function (item) {
			item.timer += 1;
			if (item.timer >= timeout) {
				dispatch(dashboardActions.setTimeOutStatus(true, item.name));
				item.timer = 0;
			}
			return item;
		})
	});
};

export default middleware
